import * as Yup from 'yup'

export const validationSchema = t => {
    return {
        email: Yup.string()
            .typeError(t('validation.valid.char'))
            .email(t('validation.invalid.email'))
            .required(t('validation.enter.email')),
        lastName: Yup.string()
            .typeError(t('validation.valid.char'))
            .required(t('validation.enter.lname')),
        firstName: Yup.string()
            .typeError(t('validation.valid.char'))
            .required(t('validation.enter.fname')),
        middleName: Yup.string()
            .ensure()
            .matches(/^[a-zA-Z ]+$/, {
                message: t('validation.valid.char'),
                excludeEmptyString: true,
            }),
        language: Yup.array().min(1, t('validation.select.language')),
        country: Yup.array().min(1, t('validation.select.country')),
    }
}
